import { BrowserRouter, Navigate, Route, Routes } from "react-router";

import FloatingActionButtonSize from "./components/FloatingButton";

import App from "./App";

import AdminLayout from "./admin/layouts/AdminLayout";
import AddClientPage from "./admin/pages/AddClientPage";
import AddDriverPage from "./admin/pages/AddDriverPage";
import AddVehiclePage from "./admin/pages/AddVehiclePage";
import ClientBookingsPage from "./admin/pages/ClientBookingsPage";
import ClientsPage from "./admin/pages/ClientsPage";
import DriversPage from "./admin/pages/DriversPage";
import EditClientPage from "./admin/pages/EditClientPage";
import EditDriverPage from "./admin/pages/EditDriverPage";
import EditVehiclePage from "./admin/pages/EditVehiclePage";
import MenuPage from "./admin/pages/MenuPage";
import PastBookingsPage from "./admin/pages/PastBookingsPage";
import RecognizeClientPage from "./admin/pages/RecognizeClientPage";
import SettingsPage from "./admin/pages/SettingsPage";
import UpcomingBookingsPage from "./admin/pages/UpcomingBookingsPage";
import VehiclesPage from "./admin/pages/VehiclesPage";

import ProtectedRoute from "./utils/ProtectedRoute";

import CheckinPage from "./pages/CheckinPage";
import DriverVoucherPage from "./pages/DriverVoucher";
import VoucherPage from "./pages/Voucher";

import AuthenticatePage from "./auth";

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="authenticate" element={<AuthenticatePage />} />
        {/*  Protected Route Start */}
        <Route path="admin-management" element={<ProtectedRoute />}>
          <Route
            index
            element={<Navigate to="/admin-management/upcoming" replace />}
          />
          <Route element={<AdminLayout />}>
            <Route path="upcoming" element={<UpcomingBookingsPage />} />
            <Route path="past" element={<PastBookingsPage />} />
            <Route path="menu" element={<MenuPage />} />
          </Route>
          <Route path="ia-add" element={<RecognizeClientPage />} />
          <Route path="add" element={<AddClientPage />} />
          <Route path="others">
            <Route path="clients">
              <Route index element={<ClientsPage />} />
              <Route path=":phone" element={<ClientBookingsPage />} />
            </Route>
            <Route path="settings" element={<SettingsPage />} />
            <Route path="drivers">
              <Route index element={<DriversPage />} />
              <Route path="add" element={<AddDriverPage />} />
              <Route path="edit">
                <Route path=":id" element={<EditDriverPage />} />
              </Route>
            </Route>
            <Route path="vehicles">
              <Route index element={<VehiclesPage />} />
              <Route path="add" element={<AddVehiclePage />} />
              <Route path="edit">
                <Route path=":id" element={<EditVehiclePage />} />
              </Route>
            </Route>
          </Route>
          <Route path="edit">
            <Route index path=":id" element={<EditClientPage />} />
          </Route>
        </Route>
        {/*  Protected Route End */}
        <Route path="voucher">
          <Route index path=":id" element={<VoucherPage />} />
        </Route>
        <Route path="driver-voucher">
          <Route index path=":id" element={<DriverVoucherPage />} />
        </Route>
        <Route path="checkin">
          <Route index path=":id" element={<CheckinPage />} />
        </Route>
        {/* Catch-all route must be last */}
        <Route
          path="*"
          element={
            <>
              <FloatingActionButtonSize />
              <App />
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
